var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPumpkinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:43;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.5,461.8c-14,6.9-29.1,10.7-44.9,10.7c-68.8,0-124.6-71.2-124.6-159s55.8-159.1,124.6-159.1 c15.9,0,31,3.8,44.9,10.7 M202.5,165c-32.4,8.3-59.8,35.3-75.9,72.5 M263.9,172.4c-12.5-6.5-26.1-10.1-40.3-10.1 c-7.2,0-14.2,0.9-21,2.6 M126.7,237.5c-3.2,8.6-6.8,18.6-9.5,27.6c-4.5,14.5-5.4,29.9-6.3,45.3c-1.8,48,14.5,97,51.7,130.5 c28.1,24.5,68.9,32.6,101.9,13.3 M362,461.8c17.1,9,37.1,12.6,56.1,10.8c10-1.8,19.9-4.5,29.9-8.2c14.5-6.3,26.3-16.3,38.1-26.3 c0.9-0.9,0.9-2.7,1.8-3.6c19-19,29.9-42.6,37.2-68c5.4-20.8,8.2-40.8,7.2-61.6c-0.9-11.8-1.8-23.6-4.5-36.2 c-3.6-13.6-7.2-26.3-13.6-39c-10.9-19-21.7-36.2-39.9-49.8c-0.9-0.9-0.9-1.8-1.8-2.7c-10-5.4-18.1-12.7-29-15.4 c-0.9,0-1.8-1.8-2.7-1.8c-26.3-9.1-56.2-8.2-80.3,5.3 M361.9,462c51.9-13.3,91-75,90.6-148.9c-0.4-73.7-39.9-134.8-91.7-147.9  M300.4,454.6c12.7,6.6,26.5,10.2,40.9,10.1c7.1,0,14-1,20.7-2.7 M360.8,165.2c-6.8-1.7-13.9-2.6-21.1-2.5 c-13.8,0.1-26.9,3.4-39.1,9.6 M300.6,172.3c-5.9-3.1-12-4.7-18.3-4.7c-6.3,0-12.6,1.6-18.5,4.8 M323.9,194.1 c-7-9.9-14.8-17.3-23.2-21.7 M300.4,454.6c31.2-16.1,54.3-73.2,54.3-141.2c0-49.3-12.1-93-30.7-119.3 M263.6,454.1 c6,3.3,12.3,5,18.8,5c6.2,0,12.2-1.5,17.9-4.5 M240.5,432.1c6.9,10,14.8,17.5,23.2,22 M263.9,172.4c-31,16.5-53.8,73.3-53.8,140.9 c0,48.9,12,92.3,30.4,118.7 M308.4,168.8l60.4-84.4c0,0-36.2-29.6-37.7-32.6s-84.3,80.9-79,115.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkinIcon);
export default __webpack_public_path__ + "static/media/pumpkinIcon.4a1d0fb044155281ad8ece0f790d59ed.svg";
export { ForwardRef as ReactComponent };